<script setup>
import { useWebSiteStore } from '@/stores/web-site.store'

const model = defineModel({ type: String, default: '' })

const webSiteStore = useWebSiteStore()
</script>

<template>
  <q-input
    v-model="model"
    :placeholder="$t('common.search')"
    :debounce="webSiteStore.getInputDebounce()"
    dense
    :outlined="false"
    borderless
    clearable
    class="search-input"
  >
    <template #prepend>
      <q-icon name="mdi-magnify" size="xs" />
    </template>
  </q-input>
</template>

<style scoped lang="scss">
.search-input {
  --search-input-border: color-mix(in srgb, var(--q-primary) 15%, transparent);
  min-width: 0;
  padding: 0 0.5rem;
  border: 1px solid var(--search-input-border);
  border-radius: 0.5rem;
  transition: border-color 0.2s;

  &:focus-within {
    border-color: var(--q-primary);
  }

  :deep(.q-field__control),
  :deep(.q-field__marginal) {
    height: 2rem;
    min-height: 2rem;
  }

  :deep(.q-field__native) {
    padding: 0;
    font-size: 0.8125rem;
  }

  :deep(.q-field__prepend) {
    padding-right: 0.375rem;
  }

  :deep(.q-field__prepend),
  :deep(.q-field__append .q-icon) {
    color: $grey-6;
  }

  :deep(.q-field__append .q-icon) {
    font-size: 1rem;
  }
}

:global(.body--dark) .search-input {
  --search-input-border: color-mix(in srgb, var(--q-primary) 30%, transparent);
}
</style>
